import { Card, Col, Empty, Row, Spin } from "antd";
import PropTypes from "prop-types";
import React from "react";

import "./KeyAdvantagesCharacteristics.scss";

const KeyAdvantagesCharacteristics = ({ characteristics, loading, title }) => (
  <Card title={title} className="key-advantages-characteristics">
    <Spin spinning={loading}>
      {characteristics.length ? (
        characteristics.map(({ name, value }) => (
          <Row key={name} className="key-advantages-characteristics__row" wrap={false}>
            <Col flex="1 1 58%" className="key-advantages-characteristics__name">
              {name}
            </Col>
            <Col flex="0 0 8px" aria-hidden="true">
              :
            </Col>
            <Col flex="1 1 42%" className="key-advantages-characteristics__value">
              {value}
            </Col>
          </Row>
        ))
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      )}
    </Spin>
  </Card>
);

KeyAdvantagesCharacteristics.propTypes = {
  characteristics: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    }),
  ),
  loading: PropTypes.bool,
  title: PropTypes.string,
};

KeyAdvantagesCharacteristics.defaultProps = {
  characteristics: [],
  loading: false,
  title: "Key Advantages",
};

export default KeyAdvantagesCharacteristics;
